import { apiRequestToken } from '../Utilidades/apiRequest';
import { ComunicadosProps, BusquedaComunicadoProps, FavoritosImportantesProps, FavoritosImportantesDeleteProps, FavoritosImportantesDeleteAllProps } from '../interfaces/comunicadosInterfaces';
import { ComunicadoVotoRequest } from '../interfaces/likeDislikesInterfaces';



export const likeOrDislike = async (votoRequest: ComunicadoVotoRequest) => {
    return apiRequestToken({
        endpoint: 'likeDislike/votar',
        body: votoRequest,
        method: 'POST',
    })
};


export const consultarLikeOrDislike = async (idComunicado:number) => {
    return apiRequestToken({
        endpoint: `likeDislike/${idComunicado}`,
        method: 'GET',
    })
};